import objectToGetParams from './objectToGetParams';
import createShareButton from './createShareButton';

type Options = {
  body?: string;
  separator?: string;
  subject?: string;
  to?:string
};

function emailLink(url: string, { subject, body, separator,to }: Options) {
  return 'mailto:'+to + objectToGetParams({ subject, body: body ? body + separator + url : url });
}

const EmailShareButton = createShareButton<Options>(
  'email',
  emailLink,
  props => ({
    subject: props.subject,
    body: props.body,
    separator: props.separator || ' ',
    to:props.to
  }),
  {
    openShareDialogOnClick: false,
    onClick: (_, link: string) => {
      window.location.href = link;
    },
  },
);

export default EmailShareButton;
